import axios from 'axios';
import BaseService from '_services/rest/base';
import SessionService from '_services/common/sessionService';
import store from '@/store';
import config from '_config';

/* eslint-disable new-parens */
class CrosswordService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${config.API_CROSSWORD_URL}`;
  }

  // Puzzle

  getPuzzles(search, slug = 'palavra-cruzadas') {
    let token = SessionService.getLocalData('_token_crossword');
    token = (token) ? `Bearer ${token}` : token;
    const instance = axios.create();

    if (!store.state.toggle.progress) {
      store.dispatch('toggle', 'progress');
    }
    return instance.get(`${this.getUrl()}api/puzzle/${slug}/search?search=${search}`, {
      headers: { Authorization: token },
    })
      .then(this.handleResponse)
      .finally(() => {
        if (store.state.toggle.progress) {
          store.dispatch('toggle', 'progress');
        }
      });
  }

  // Autentication

  checkToken(token) {
    return axios.get(`${this.getUrlPassword()}find/${token}`)
      .then(response => response)
      .catch(error => {
        console.log('error', error);
        throw error;
      });
  }

  getToken(params) {
    return axios.post(`${this.getUrl()}oauth/token`, params)
      .then(result => {
        this.setLocalStorageToken(result.data);
      })
      .catch(error => {
        throw this.error(error);
      });
  }

  login(user) {
    return this.getToken({
      username: user.username,
      password: user.password,
      client_id: config.CLIENT_ID_CROSSWORD,
      client_secret: config.CLIENT_SECRET_CROSSWORD,
      grant_type: config.GRANT_TYPE,
    });
  }

  refreshToken() {
    return this.getToken({
      refresh_token: SessionService.getLocalData('_refresh_token_crossword'),
      client_id: config.CLIENT_ID,
      client_secret: config.CLIENT_SECRET,
      grant_type: 'refresh_token',
    });
  }

  setLocalStorageToken(result) {
    // axios.defaults.headers.common.Authorization = `${tokenType} ${token}`
    SessionService.setLocalData('_token_crossword', result.access_token);
    SessionService.setLocalData('_refresh_token_crossword', result.refresh_token);
  }

  setCookie(expires, user) {
    SessionService.setCookie('_id', user.id, expires);
  }
}

export default new CrosswordService();
